import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const CoursesPage = lazy(() => import('../pages/courses/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const PaymentPage = lazy(() => import('../pages/payment/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/courses',
    element: <CoursesPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/post',
    element: <BlogPostPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/payment',
    element: <PaymentPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
